import Axios from "axios";
import Vue from "vue";
import ENV from "@/utils/constants/environment";
import store from "@/store";
import router from "@/router";
import UserService from "@/services/user.service";
import User from "@/model/User";

import { Notification } from "element-ui";

const LOGIN_URL = ENV.BASE_URL + "/oauth/token";

export default {
  async login(username: string, password: string) {
    const formData = new FormData();
    formData.set("username", username);
    formData.set("password", password);
    formData.set("grant_type", "password");
    try {
      const response = await Axios.request({
        method: "POST",
        url: LOGIN_URL,
        headers: {
          "Content-Type": "multipart/form-data"
        },
        auth: {
          username: "podo",
          password: "PoDo?2020"
        },
        data: formData
      });
      localStorage.setItem("token", response.data.access_token);
      localStorage.setItem("refresh_token", response.data.refresh_token);
      UserService.getAuthenticatedUser().then(response => {
        const jsonUser = response.data.data;
        const loggedUser: User = new User(
          jsonUser.id,
          jsonUser.name,
          jsonUser.lastName,
          jsonUser.socialDenomination,
          jsonUser.email,
          jsonUser.phone,
          jsonUser.town,
          jsonUser.address,
          jsonUser.postalCode,
          jsonUser.cifNif,
          jsonUser.contactName,
          jsonUser.contactLastName,
          jsonUser.role,
          "",
          jsonUser.business,
          jsonUser.comercialName,
          jsonUser.nationality
        );
        store.dispatch("setUserLogged", { loggedUser });
        router.push("/new-client");
      });
      return Promise.resolve(true);
    } catch (e) {
      return Promise.reject();
    }
  },
  logout() {
    localStorage.clear();
    store.dispatch("clearState");
    router.push({ path: "/" });
  },
  sessionExpired() {
    if (!Vue.$cookies.isKey("token")) {
      this.logout();
      Vue.$cookies.remove("token");
      Notification.error(
        "Su sesión ha caducado. Debe iniciar sesión de nuevo."
      );
      return;
    }
  }
};
